import * as React from 'react';
import { Button, Card, Dropdown, Icon } from 'semantic-ui-react';
export var ReportCard = function (_a) {
    var _b;
    var report = _a.report, ReportLink = _a.ReportLink;
    return (<Card data-testid='report-card'>
		<Card.Content>
			<Card.Header>
				{report.name}
				<ActionMenu history={(_b = report.dataVersions) !== null && _b !== void 0 ? _b : null} id={report.id} ReportLink={ReportLink}/>
			</Card.Header>
		</Card.Content>
		<Button attached primary as={React.useCallback(function (props) { return (<ReportLink id={report.id}>
						<a {...props}/>
					</ReportLink>); }, [report.id, ReportLink])} data-testid='open-report-button'>
			Vidět více <Icon name='arrow right'/>
		</Button>
	</Card>);
};
export var DropdownItem = function (_a) {
    var id = _a.id, index = _a.index, record = _a.record, ReportLink = _a.ReportLink;
    var link = React.useCallback(function (props) { return (<ReportLink historized={record.id} id={id}>
				<a {...props}/>
			</ReportLink>); }, [id, record.id, ReportLink]);
    return (<Dropdown.Item as={link} data-testid={"historized-".concat(index)} key={record.id}>
			{record.historizedAt}
		</Dropdown.Item>);
};
export var ActionMenu = function (_a) {
    var id = _a.id, history = _a.history, ReportLink = _a.ReportLink;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    return (<Dropdown data-testid='open-dropdown-button' icon='ellipsis vertical' open={open} onClose={function () {
            setOpen(false);
        }} onOpen={function () {
            setOpen(true);
        }}>
			{open ? (<Dropdown.Menu>
					<Dropdown.Header as='h4'>
						{history !== null && history.length > 0 ? 'Předchozí verze' : 'Žádné předchozí verze'}
					</Dropdown.Header>
					{history !== null
                ? history.map(function (record, index) { return (<DropdownItem id={id} index={index} key={index} record={record} ReportLink={ReportLink}/>); })
                : null}
				</Dropdown.Menu>) : null}
		</Dropdown>);
};
